import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Line, mixins } from "vue-chartjs";
import { chartData } from "@/models/graph/chart_data"

@Component({
  extends: Line,
  mixins: [mixins.reactiveProp],
})
export default class ActivityChart extends Vue {
  @Prop() chartData!: chartData;

  protected options = {
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
          ticks: {
              stepSize: 1,
              beginAtZero: true,
       display:true
          }
      }],
      xAxes: [{
        ticks: {
            beginAtZero: true,
        }
    }],
    }
  };

  mounted() {
    this.renderChart(
     this.chartData,
      this.options
    );
    this.$emit('mountedGraph');
  }
  public renderChart!: (data: chartData, options: {}) => void;
}

